// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__22HhA","col":"styles_col__f4gtl","fulfillmentStatus":"styles_fulfillmentStatus__3hsC-","emailCol":"styles_emailCol__2GhDf"};